import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { GenericModal } from "@Shared/components/modals";
import { defineComponent, ref } from "@vue/composition-api";
export default defineComponent({
  name: "ConfirmDeleteSegmentModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    deletingSegment: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, {
    emit
  }) {
    const confirmModal = ref();
    const handleDeleteSegment = () => {
      emit("delete-segment", confirmModal.value);
    };
    const show = () => {
      var _confirmModal$value;
      (_confirmModal$value = confirmModal.value) == null ? void 0 : _confirmModal$value.show();
    };
    const hide = () => {
      var _confirmModal$value2;
      (_confirmModal$value2 = confirmModal.value) == null ? void 0 : _confirmModal$value2.hide();
    };
    const handleHidden = () => {
      emit("hidden");
    };
    return {
      confirmModal,
      handleDeleteSegment,
      show,
      hide,
      handleHidden
    };
  }
});